<template lang="pug">
  div.item-input-message.f.fm.flex-between.px12.py6
    div.wrap-input.pr6
      input(v-model="value"
        type="text"
        placeholder="Type message here..."
        @keydown.enter="onSend"
        @compositionstart="composing=true"
        @compositionend="composing=false").fz16
      //- input(v-model="value"
        type="text"
        placeholder="Type message here...").fz16
    div.wrap-icon.f.fm
      v-icon(@click="onSend"
        :color="(value == '' || value.length >= 200) ? pallete.$secondary_text_color : pallete.$active_color").mr4 mdi-send
      div.wrap-current-bubble
        v-icon(@click="showBubbleSelector = !showBubbleSelector") {{currentBubble.icon}}
        transition
          div(v-if="showBubbleSelector").wrap-bubble-selector.px4.py4
            div(v-for="item in bubbles").py6
              v-icon(@click="onBubbleSelector(item)"
                :color="(currentBubble.icon == item.icon) ? pallete.$active_color : pallete.$secondary_text_color") {{item.icon}}
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

$icon_wrapper_size: 48px;
.item-input-message {
  width: 100%;
  max-width: 340px;
  background: $primary_bg_color;
  border: $basic_border;
  border-radius: 3px;
  filter: $drop_shadow;
  .wrap-input {
    width: calc(100% - #{$icon_wrapper_size});
    input {
      width: 100%;
      outline: none;
    }
  }
  .wrap-icon {
    width: $icon_wrapper_size;
    .wrap-current-bubble {
      position: relative;
      .wrap-bubble-selector {
        position: absolute;
        left: -2px;
        bottom: calc(100% + 14px);
        background: $primary_bg_color;
        border-radius: 3px;
        filter: $drop_shadow;
      }
    }
    .v-leave-active, .v-enter-active {
      transition: all 400ms $ease_out_expo;
    }
    .v-enter, .v-leave-to {
      opacity: 0;
      transform: translateY(8px);
    }
    .v-enter-to, .v-leave {
      opacity: 1;
      transform: translateY(0px);
    }
  }
}
</style>

<script>
import database from '@/database'

export default {
  data () {
    return {
      value: '',
      sendActive: false,
      preventSend: false,
      composing: false,
      showBubbleSelector: false,
      currentBubble: { type: 'normal', icon: 'mdi-comment-outline' },
      bubbles: [
        { type: 'normal', icon: 'mdi-comment-outline' },
        { type: 'thinking', icon: 'mdi-thought-bubble-outline' },
        { type: 'shout', icon: 'mdi-decagram-outline' }
      ]
    }
  },
  props: {
    me: {
      type: Object,
      required: true
    }
  },
  created () {
    if (this.me.bubbleType) {
      this.currentBubble = this.bubbles.filter(e => e.type === this.me.bubbleType)[0]
    } else {
      this.currentBubble = this.bubbles[0]
    }

    // デモ用
    // setInterval(this.autoMessage, 5000)
  },
  methods: {
    // async autoMessage () {
    //   // const msgs = [
    //   //   'いいね！', 'いえい！', 'やっぱりね', 'どうなんだろ？', 'Hello!', 'Hahahaha', 'ワロタw', 'wwwww', 'orz', '（笑）', '草', 'こっちだよ', 'どうしよ',
    //   //   'わからん！', 'Oww', '88888888', 'ワクワク'
    //   // ]
    //   const msgs = ['何これ？', '変なのー', 'うける笑', 'ワロタw', 'wwwww', 'orz', '（笑）', '草', 'これきになる！', 'なんだこれは！？', 'こっちだよ']
    //   await this.sleep(Math.floor(Math.random() * 1000))
    //   this.value = msgs[Math.floor(Math.random() * msgs.length)]
    //   this.onSend()
    // },
    async onSend (event) {
      if (this.value.length >= 200) {
        alert('Too Long!')
        return
      }

      if (event && event.isComposing) return

      if (this.value === '' || this.preventSend || this.composing) return
      this.preventSend = true
      
      await database.userCollection().update(this.me.id, { bubbleType: this.currentBubble.type })
      const msgObj = {
        value: this.value,
        createdBy: this.me.id,
        createdAt: new Date(),
        createdFrom: this.me.pos,
        class: 'message',
        type: this.currentBubble.type,
        slide: this.$route.params.slideId
      }
      
      await database.slideCollection()
        .sendMessage(this.$route.params.slideId, msgObj)
      // await database.userCollection().sendMessage(this.me.id, msgObj)

      this.value = ''
      this.preventSend = false
    },
    onBubbleSelector (bubble) {
      this.currentBubble = bubble
      this.showBubbleSelector = !this.showBubbleSelector
    }
  }
}
</script>